import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import AbsoluteTopBarFilter from '../components/AbsoluteTopBarFilter'
import LanguageSelector from '../components/LanguageSelector'
import Nav from '../components/Nav'
import { SearchFiltersProvider } from '../components/SearchFiltersContext'
import Modal from '../components/MyModal'
import MyButton from '../components/buttons'
import { IoClose } from 'react-icons/io5'
import MenuLogin from '../components/MenuLogin'
import MenuOptions from '../components/MenuOptions'
import { ScreenModeType } from '../pages/LoginRegisterPages'
import { useNavigate } from 'react-router-dom'

export default function Header() {
  const { t, i18n } = useTranslation()
  const [, setIsUserClicked] = useState(false)
  const [, setIsDotsClicked] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const userMenuRef = useRef<HTMLDivElement | null>(null)

  const handleSwitchMode = (mode: ScreenModeType) => {
    navigate('/login')
    const url = new URL(window.location.href)
    url.searchParams.set('screen', mode)
    window.history.pushState({}, '', url)
  }
  const dotsMenuRef = useRef<HTMLDivElement | null>(null)
  const navigate = useNavigate()

  useEffect(() => {
    const defaultLanguage = 'fr-FR'
    if (!i18n.language) {
      i18n.changeLanguage(defaultLanguage)
    }
  }, [i18n])

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        userMenuRef.current &&
        !userMenuRef.current.contains(event.target as Node)
      ) {
        setIsUserClicked(false)
      }
      if (
        dotsMenuRef.current &&
        !dotsMenuRef.current.contains(event.target as Node)
      ) {
        setIsDotsClicked(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className='relative bg-redpink max-h-60'>
      <div className='hidden xl:block w-full bg-anthracite text-redpink pt-5 pb-14'>
        <div className='max-w-7xl mx-auto flex'>
          <div className='w-11/12 flex-grow'>
            <SearchFiltersProvider>
              <AbsoluteTopBarFilter isVisible={false} />
            </SearchFiltersProvider>
          </div>

          <div className='w-1/12 text-3xl text-white text-right'>
            <div className='flex justify-end h-9'>
              <MenuLogin className='mr-3' />
              <MenuOptions />
            </div>
            <div className='flex justify-end text-anthracite h-9'>
              <div className='bg-white rounded-md h-40px'>
                <LanguageSelector />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Nav onSwitchMode={handleSwitchMode} />

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className='p-4 bg-white rounded-md max-w-sm mx-auto w-full'>
          <p className='text-center mb-4'>{t('create-ad.must-be-logged-in')}</p>
          <MyButton
            variant='close-modal'
            className='absolute top-2 right-2 bg-redpink rounded-full p-1'
            onClick={() => setIsModalOpen(false)}
          >
            <IoClose className='text-xl' />
          </MyButton>
          <div className='w-full text-center mt-4'>
            <MyButton
              to='/login'
              className='w-full'
              variant='redpink-anthracite'
            >
              {t('create-ad.login')}
            </MyButton>
          </div>
        </div>
      </Modal>
    </div>
  )
}
